// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2WeMj","bigColWidth":"Table_bigColWidth__3D-4S","biggerColWidth":"Table_biggerColWidth__32WgY","row":"Table_row__2YisR","col":"Table_col__-1l4g"};